export default __webpack_public_path__ + "static/media/ift.1e154734.svg";